import { Box, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";

import { SITE_STEPS, marketingPalette } from "@/components/marketing/tokens";
import { FOOTER_PAYMENT_METHODS } from "./footerContent";

/** The published line carries no year, so neither does this one. */
const COPYRIGHT = "\u00A9 Webshare Proxy";
const PAYMENT_LABEL = "payment methods";
/** The grey the marks are labelled in; no palette role reaches it. */
const LABEL_INK = "#89949C";
const MARK_WIDTH = "38.4px";

/**
 * Each mark is named. The published images are `alt=""`, which leaves a reader
 * who cannot see them with a label and nothing under it.
 */
function PaymentMethods() {
  return (
    <Box
      sx={(theme) => ({
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        columnGap: 3,
        rowGap: 3,
        [theme.breakpoints.down(SITE_STEPS.tiny)]: {
          justifyContent: "space-between",
          columnGap: 2,
          width: "100%",
        },
      })}
    >
      <Typography
        component="p"
        sx={{
          fontSize: "11.04px",
          fontWeight: 300,
          lineHeight: "20px",
          letterSpacing: "1px",
          textTransform: "uppercase",
          color: LABEL_INK,
        }}
      >
        {PAYMENT_LABEL}
      </Typography>
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          columnGap: 2,
          rowGap: 2,
        }}
      >
        {FOOTER_PAYMENT_METHODS.map((method) => (
          <Box
            component="img"
            key={method.name}
            src={method.src}
            alt={method.name}
            loading="lazy"
            sx={{
              width: MARK_WIDTH,
              maxWidth: "100%",
              verticalAlign: "middle",
            }}
          />
        ))}
      </Box>
    </Box>
  );
}

/** The copyright line, which the small footer sets under its wordmark too. */
export function Copyright() {
  return (
    <Typography
      component="p"
      sx={{
        fontSize: 14,
        fontWeight: 300,
        lineHeight: "20px",
        letterSpacing: "0.64px",
        // The published line carries both dims, so it renders at an effective
        // 0.49 rather than 0.7. Dropping either is a visible change.
        color: alpha(marketingPalette.surface, 0.7),
        opacity: 0.7,
      }}
    >
      {COPYRIGHT}
    </Typography>
  );
}

/**
 * The strip under the rule: the copyright on one side, the card marks on the
 * other, stacking below 768.
 */
export default function FooterLegal() {
  return (
    <Box
      sx={(theme) => ({
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        [theme.breakpoints.down(SITE_STEPS.card)]: {
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "flex-start",
          rowGap: 3,
          columnGap: 3,
        },
      })}
    >
      <Copyright />
      <PaymentMethods />
    </Box>
  );
}
